<template>
  <div
    v-editable="blok"
    class="EmployeeListing"
    :class="desktopWidth('full')"
  >
    <div class="text-center mobOnly:px-12 mb-16 desk:mb-64 desk:max-w-680 desk:mx-auto">
      <div class=" type-headline-lg desk:type-headline-2xl">{{ blok.headline }}</div>
      <div class="empty:hidden mt-12 type-sm desk:type-base" v-html="renderRichText(blok.text)" />
    </div>
    <SideScroll>
      <div
        v-if="blok.tabs.length > 1"
        class="flex w-full type-headline-sm mb-16"
      >
        <div
          v-for="(tab, index) in blok.tabs"
          :key="tab._uid"
          class="relative flex items-center justify-center shrink-0 gap-8 px-12 pb-16 type-headline-sm cursor-pointer"
          :class="[ `basis-1/${blok.tabs.length}`]"
          @click="selectedTab = index"
        >
          <div class="leading-single whitespace-nowrap"> {{ tab.tabName }}</div>
          <div
            class="w-24 h-24 flex justify-center items-center rounded-full type-xxs-medium leading-single"
            :class="{
              'bg-brandPrimary': selectedTab === index,
              'bg-light': selectedTab !== index,
            }"
          >
            {{ countCards(tab) }}
          </div>
          <div
            class="customBorder absolute bottom-0 w-full"
            :class="{
              'bg-brandPrimary h-3': selectedTab === index,
              'bg-light h-1': selectedTab !== index,
            }"
          />
        </div>
      </div>
    </SideScroll>

    <div>
      <EmployeeTab :blok="currentTabContent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmployeeTabProps, StoryBlokPropBase } from '~/constants/types/storyblok';
import useDesktopWidth from '~/composeables/useDesktopWidth';
import { ISbRichtext } from 'storyblok-js-client';

type Props = StoryBlokPropBase & {
  headline: string,
  text: ISbRichtext,
  tabs: EmployeeTabProps[],
}

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth } = useDesktopWidth(props);

const selectedTab = ref(0);
const currentTabContent = computed(()=> {
  return props.blok.tabs[selectedTab.value];
});

// Function to count the number of EmployeeCards in each tab
const countCards = (tab: EmployeeTabProps) => {
  return tab.groups.reduce((total, group) => {
    return total + (group.cards ? group.cards.length : 0);
  }, 0);
};

</script>

<style lang="postcss">
/*
(note: this is not scoped css)
If there are two EmployeeListing it gets a border between and is moved up
This is not perfect since user can change spacehandler bottom margin, but works with default settings
 */
.SpaceHandler:has(.EmployeeListing) + .SpaceHandler:has(.EmployeeListing) {
  @apply border-t border-light pt-16 desk:pt-64 -mt-64;
}
</style>
